module.exports = __webpack_public_path__ + "img/产品优势_实时处理和流式计算.599f9618.png";